import Icon from '@/common/components/Icon';
import { Info, MiddleInfoWrapper, Title } from '../../YourScore.styles';
import { Colors } from '@/common/colors/colors';
import { ConfirmationsPerHour, MainWrapper } from './MainScore.styles';
import { getColor } from '../../helpers/getColor';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import Loading from '@/common/components/Loading';

const MainScore = ({ dailyContactsHistory, hours, isLoading }) => {
	const { translation } = useTranslationContext();

	if (isLoading) {
		return (
			<MainWrapper>
				<Loading />
			</MainWrapper>
		);
	}

	if (!dailyContactsHistory || hours === null) {
		return (
			<MainWrapper>
				<MiddleInfoWrapper>{translation.noData}</MiddleInfoWrapper>
			</MainWrapper>
		);
	}

	if (dailyContactsHistory.downloaded === 0) {
		return (
			<MainWrapper>
				<Title color={Colors.gray}>
					{'-'}
					<ConfirmationsPerHour color={Colors.gray}>
						{translation.confirmations_per_hour}
					</ConfirmationsPerHour>
				</Title>
				<MiddleInfoWrapper>
					{translation.work_has_not_yet_started_today}
				</MiddleInfoWrapper>
			</MainWrapper>
		);
	}

	if (dailyContactsHistory.downloaded > 0 && hours === 0) {
		return (
			<MainWrapper>
				<Title color={Colors.gray}>
					{'-'}
					<ConfirmationsPerHour color={Colors.gray}>
						{translation.confirmations_per_hour}
					</ConfirmationsPerHour>
				</Title>
				<MiddleInfoWrapper>
					<Icon name='warning' size={16} color={Colors.gray} />
					{translation.you_have_not_entered_working_hours_yet}
				</MiddleInfoWrapper>
			</MainWrapper>
		);
	}

	const confirmed = dailyContactsHistory.confirmed || 0;
	const rate = hours > 0 ? confirmed / hours : null;

	return (
		<MainWrapper>
			<Title color={getColor(rate)}>
				{rate !== null ? rate.toFixed(2) : '-'}{' '}
				<ConfirmationsPerHour color={getColor(rate)}>
					{translation.confirmations_per_hour}
				</ConfirmationsPerHour>
			</Title>
			<MiddleInfoWrapper>
				<Info>{confirmed}</Info>
				<Info>{translation.confirmations}</Info>⋅
				<Info>{hours}</Info>
				<Info>{translation.your_score_hours}</Info>
			</MiddleInfoWrapper>
		</MainWrapper>
	);
};

export default MainScore;
